import React from 'react';

import './ActionWrapper.css';

// ActionWrapper — thin stacking container for action primitives on
// the Desktop canvas. No window-level overlay; each primitive owns
// its own per-row overlay <img>, matching the source surfaces in
// LodgingController / AntiJuice / LodgingSelector.
export function ActionWrapper({ children }) {
    return (
        <div className={'action-wrapper'}
             data-testid={'action-wrapper'}>
            {children}
        </div>
    );
}

export default ActionWrapper;
